import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	currentUserRole: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	placeholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	currentUserRole: {
		id: 'issue-field-role-picker.edit.current-user-role',
		defaultMessage: 'You',
		description: 'text shown to user on Role Dropdown to show the role,user belongs to',
	},
	placeholder: {
		id: 'issue-field-role-picker.edit.placeholder',
		defaultMessage: 'Select Roles',
		description: 'Placeholder text shown in the role dropdown',
	},
});
export default messages;
